module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe5_cn@3x.f759210b.png";